/* KS · Kunstsokken behaviours (port of the prototype JS). No dependencies. Loaded as a module after theme.js. */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---- header USP strip: one message per view on mobile, arrows step through and wrap ---- */
  function initUsp(root) {
    $$('[data-ks-usp]', root).forEach((u) => {
      if (u.dataset.ksReady) return; u.dataset.ksReady = '1';
      const t = $('[data-ks-usp-track]', u); if (!t) return;
      const n = t.children.length; if (n < 2) return;
      const idx = () => Math.round(t.scrollLeft / t.clientWidth);
      const go = (i) => t.scrollTo({ left: (((i % n) + n) % n) * t.clientWidth, behavior: 'smooth' });
      $('[data-ks-usp-prev]', u)?.addEventListener('click', () => go(idx() - 1));
      $('[data-ks-usp-next]', u)?.addEventListener('click', () => go(idx() + 1));
      let timer = null;
      const auto = () => { timer = setInterval(() => { if (matchMedia('(max-width: 999px)').matches) go(idx() + 1); }, 4000); };
      auto();
      u.addEventListener('pointerdown', () => { clearInterval(timer); }, { once: true });
    });
  }

  /* ---- museum marquee: CSS animation, JS only measures the set and clones enough copies ---- */
  function initMarquee(root) {
    $$('[data-ks-marquee]', root).forEach((m) => {
      if (m.dataset.ksReady) return; m.dataset.ksReady = '1';
      const track = $('.ks-marquee__track', m), set = $('.ks-marquee__set', m);
      if (!track || !set) return;
      const speed = matchMedia('(min-width: 1000px)').matches ? 60 : 42; let lastW = 0;
      const setup = () => {
        const w = set.offsetWidth; if (!w || w === lastW) return; lastW = w;
        const need = Math.ceil(m.offsetWidth / w) + 2;
        while (track.children.length < need) track.appendChild(set.cloneNode(true));
        track.style.setProperty('--set-w', w + 'px'); track.style.animationDuration = (w / speed) + 's'; track.classList.add('is-ready');
      };
      setup(); window.addEventListener('load', () => { setup(); requestAnimationFrame(setup); });
      window.addEventListener('resize', setup); setTimeout(setup, 300); setTimeout(setup, 1500);
      /* the logos are deferred (see initDefer): re-measure the set as each real logo arrives */
      m.addEventListener('load', () => { lastW = 0; setup(); }, true);
    });
  }

  /* ---- deferred images: containers marked data-ks-defer hold <img data-src data-srcset> with an empty SVG placeholder. They are
     swapped in when the container comes within 500px of the viewport (all at once, so a horizontal row is complete before the
     user swipes), and images added later inside an activated container (fetched discover rows, marquee clones) are swapped at
     once. Deterministic in every browser: Chrome would load loading="lazy" images up to 2500px below the fold on slow networks,
     Safari does not lazy-load inside horizontal scrollers or the moving marquee. ---- */
  const canHover = matchMedia('(hover: hover)');
  const swapDeferred = (root, priority, includeLate) => {
    const imgs = root.matches && root.matches('img[data-src]') ? [root] : $$('img[data-src]', root);
    imgs.forEach((img) => {
      /* a product card's hover image is never shown on touch devices: leave it as the empty placeholder there */
      if (img.classList.contains('product-card__image--secondary') && !canHover.matches) return;
      /* "late" images (far end of a slider) wait for the visitor to touch or scroll that slider */
      if (img.hasAttribute('data-ks-late') && !includeLate) return;
      /* eager: the swap itself decides the moment, not the browser's own lazy margin (which ignores horizontal distance rules we need) */
      img.loading = 'eager'; if (priority) img.setAttribute('fetchpriority', priority);
      if (img.dataset.srcset) img.srcset = img.dataset.srcset; img.src = img.dataset.src; delete img.dataset.src; delete img.dataset.srcset;
    });
  };
  const deferHandler = (io) => (entries) => {
    entries.forEach((en) => { if (!en.isIntersecting) return; const c = en.target; io.unobserve(c); c.dataset.ksDeferOn = '1'; swapDeferred(c); });
  };
  const hasIO = 'IntersectionObserver' in window;
  const deferIO = hasIO ? new IntersectionObserver((e) => deferHandler(deferIO)(e), { rootMargin: '500px 0px 500px 0px' }) : null;
  /* "far": big single photos (feature and founders sections) get a 1500px head start so they never pop in while scrolling */
  const deferFarIO = hasIO ? new IntersectionObserver((e) => deferHandler(deferFarIO)(e), { rootMargin: '1500px 0px 1500px 0px' }) : null;
  function initDefer(root) {
    const list = root.matches && root.matches('[data-ks-defer]') ? [root] : $$('[data-ks-defer]', root);
    list.forEach((c) => {
      if (c.dataset.ksDeferSeen) return; c.dataset.ksDeferSeen = '1';
      /* inside a closed cart drawer (laid out but visibility:hidden, so it would "intersect"): wait for the drawer to open (initDrawerDefer) */
      const dr = c.closest('cart-drawer'); if (dr && !dr.hasAttribute('open')) return;
      if (!hasIO) { c.dataset.ksDeferOn = '1'; swapDeferred(c); return; }
      (c.dataset.ksDefer === 'far' ? deferFarIO : deferIO).observe(c);
    });
    /* nodes inserted into a container that is already active */
    if (root !== document && root.closest && root.closest('[data-ks-defer-on]')) swapDeferred(root);
  }

  /* ---- cart drawer (7 Sep 2026): its deferred images (empty-cart recommendations) load the moment the drawer opens — never at page
     load, where they would compete with the hero — and containers inside are marked active so rows inserted later swap at once ---- */
  function initDrawerDefer(root) {
    const list = root.matches && root.matches('cart-drawer') ? [root] : $$('cart-drawer', root);
    list.forEach((d) => {
      if (d.dataset.ksDrawerDefer) return; d.dataset.ksDrawerDefer = '1';
      const swap = () => { if (!d.hasAttribute('open')) return; $$('[data-ks-defer]', d).forEach((c) => { c.dataset.ksDeferOn = '1'; }); swapDeferred(d); };
      new MutationObserver(swap).observe(d, { attributes: true, attributeFilter: ['open'] });
      swap();
    });
  }

  /* ---- count bubbles marked data-ks-zero-hide (empty-cart drawer header, 7 Sep 2026) are hidden while they read 0 and reappear
     as soon as Impact writes the new count into the same element after an add ---- */
  function initZeroHide(root) {
    const list = root.matches && root.matches('[data-ks-zero-hide]') ? [root] : $$('[data-ks-zero-hide]', root);
    list.forEach((el) => {
      if (el.dataset.ksZeroHideOn) return; el.dataset.ksZeroHideOn = '1';
      const upd = () => { el.hidden = parseInt((el.textContent || '').trim(), 10) === 0; };
      new MutationObserver(upd).observe(el, { childList: true, characterData: true, subtree: true });
      upd();
    });
  }

  /* ---- museum-collab meta line (snippets/ks-meta-line.liquid, 11 Sep 2026): "Museum MORE x Kunstsokken" is always shown;
     the original artist and year ([data-ks-extra], rendered hidden) are revealed one by one only while the line keeps its
     height, and re-fitted when the width changes or the web font arrives — the collab never drops, the block never grows. ---- */
  function fitMeta(p) {
    const extras = $$('[data-ks-extra]', p);
    extras.forEach((el) => { el.hidden = true; });
    const base = p.getBoundingClientRect().height;
    for (const el of extras) { el.hidden = false; if (p.getBoundingClientRect().height > base + 1) { el.hidden = true; break; } }
  }
  let metaRO;
  function initMetaFit(root) {
    const list = root.matches && root.matches('[data-ks-meta-fit]') ? [root] : $$('[data-ks-meta-fit]', root);
    if (!list.length) return;
    if (!metaRO && 'ResizeObserver' in window) metaRO = new ResizeObserver((entries) => entries.forEach((en) => {
      const p = en.target; const w = Math.round(en.contentRect.width);
      if (p._ksMetaW === w) return; p._ksMetaW = w; fitMeta(p);
    }));
    list.forEach((p) => { if (p.dataset.ksMetaFitOn) return; p.dataset.ksMetaFitOn = '1'; fitMeta(p); if (metaRO) metaRO.observe(p); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => list.forEach(fitMeta));
  }

  /* ---- horizontal deferral for the product gallery (snippets/media.liquid, photos 3+): on phones the carousel is horizontal, so
     Chrome's own lazy loading fetched every photo at once. Each slide is observed against the carousel itself with a margin of
     1.2 slide widths, so the next photo loads one swipe ahead; a variant switch that jumps to a later photo swaps it at once.
     On desktop (≥ 1000px) everything is swapped immediately: thumbnails must react instantly there. ---- */
  const desktopMQ = matchMedia('(min-width: 1000px)');
  function initDeferX(root) {
    const lists = root.matches && root.matches('[data-ks-defer-x]') ? [root] : $$('[data-ks-defer-x]', root);
    lists.forEach((list) => {
      if (list.dataset.ksDeferXOn) return; list.dataset.ksDeferXOn = '1';
      /* product sliders (homepage featured collections, recommendations, discover row): nothing horizontal at page load — the
         vertical approach (initDefer on the same element or an ancestor) loads the first cards, and the first touch, wheel,
         keyboard or arrow-driven scroll on the slider loads every remaining card, "late" ones included, left to right */
      if (list.dataset.ksDeferX === 'carousel') {
        /* not "once": a discover row gets new (late) cards on every tab switch and must react again; the swap is a no-op when nothing is left */
        const allNow = () => { if (list.querySelector('img[data-src]')) swapDeferred(list, 'low', true); };
        ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll'].forEach((t) => list.addEventListener(t, allNow, { passive: true, capture: true }));
        return;
      }
      /* the product gallery on desktop: load the other photos as soon as the hero has arrived (or after 2.5 s at the latest), low
         priority — thumbnails and zoom stay near-instant, but the hero never shares its bandwidth with six other photos */
      if (desktopMQ.matches || !('IntersectionObserver' in window)) {
        const hero = list.querySelector('img[fetchpriority="high"]') || list.querySelector('.product-gallery__media img:not([data-src])');
        let done = false; const rest = () => { if (done) return; done = true; swapDeferred(list, 'low', true); };
        if (!hero || hero.complete) rest(); else { hero.addEventListener('load', rest, { once: true }); hero.addEventListener('error', rest, { once: true }); setTimeout(rest, 2500); }
        return;
      }
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (!en.isIntersecting) return; io.unobserve(en.target); swapDeferred(en.target); });
      }, { root: list, rootMargin: '0px 120% 0px 120%' });
      $$(':scope > *', list).forEach((slide) => { if (slide.querySelector('img[data-src]')) io.observe(slide); });
      const all = () => { io.disconnect(); swapDeferred(list, 'low', true); };
      desktopMQ.addEventListener('change', (e) => { if (e.matches) all(); });
      list.addEventListener('ks:swap-all', all);
      /* the first interaction with the gallery (swipe, thumbnail, dots, zoom button, keyboard) loads the rest, before Impact
         hands the photos to the zoom viewer: the viewer reads the <img> sources at that moment, so this runs in the capture phase */
      const gallery = list.closest('product-gallery, .product-gallery') || list;
      ['pointerdown', 'touchstart', 'keydown'].forEach((t) => gallery.addEventListener(t, all, { once: true, passive: true, capture: true }));
    });
  }
  /* Impact announces variant changes; if the new variant has its own photo, make sure it is loaded right away */
  document.addEventListener('variant:change', (e) => {
    const v = e.detail && e.detail.variant; const mid = v && v.featured_media && v.featured_media.id; if (!mid) return;
    const slide = document.querySelector('.product-gallery__media[data-media-id="' + mid + '"]'); if (slide) swapDeferred(slide);
  });

  /* ---- discovery module: tab strip + product row loaded through the Section Rendering API ---- */
  function initDiscover(root) {
    $$('[data-ks-disc]', root).forEach((m) => {
      if (m.dataset.ksReady) return; m.dataset.ksReady = '1';
      const tabs = $('[data-ks-disc-tabs]', m), row = $('[data-ks-disc-row]', m), th = $('[data-ks-disc-thumb]', m);
      if (!tabs || !row) return;
      const cache = {};
      const lim = parseInt(m.dataset.limit || '0', 10) || 0;
      const excl = m.dataset.exclude || '';
      const upd = () => {
        const vis = row.clientWidth / row.scrollWidth;
        if (th) { th.style.width = Math.min(vis, 1) * 100 + '%'; th.style.left = (row.scrollLeft / row.scrollWidth * 100) + '%'; }
        m.classList.toggle('at-start', row.scrollLeft < 4);
        m.classList.toggle('at-end', row.scrollLeft + row.clientWidth >= row.scrollWidth - 4);
        m.classList.toggle('no-scroll', vis >= 1);
      };
      const activate = (b) => {
        $$('.ks-disc__tab', tabs).forEach((x) => x.classList.toggle('is-on', x === b));
        tabs.scrollTo({ left: b.offsetLeft - tabs.clientWidth / 2 + b.offsetWidth / 2, behavior: 'smooth' });
      };
      /* the fetched row carries every product of the collection (helper section); the tab decides what shows: the type-prefix list
         (data-types, one prefix per storefront language because product.type is translated; empty = unfiltered), the artist/museum
         rules (data-no-packs: bundle-typed products and pack/bundel/bundle titles are never singles — mistranslated bundle types),
         the bundle mode (data-bundles none | fallback | append + data-bundles-limit, 7 Sep 2026: the collection's bundles and gift
         sets after the singles), the current product and the limit (max singles). A tab that ends up empty is hidden. */
      const show = (html, b) => {
        const prefs = (b.dataset.types || '').toLowerCase().split(',').map((s) => s.trim()).filter(Boolean);
        const noPacks = b.dataset.noPacks === '1', bmode = noPacks ? (b.dataset.bundles || 'none') : 'none';
        const blim = parseInt(b.dataset.bundlesLimit || '6', 10) || 6;
        const tmp = document.createElement('ul'); tmp.innerHTML = html;
        const singles = [], bundles = [];
        $$(':scope > li', tmp).forEach((li) => {
          if (excl && li.dataset.id === excl) return;
          const t = (li.dataset.type || '').toLowerCase();
          const name = (($('.ks-disc__name', li) || {}).textContent || '').toLowerCase();
          const isBundle = li.dataset.bundle === '1' || /pack|bundel|bundle/.test(name);
          const okType = !prefs.length || prefs.some((p) => t.startsWith(p));
          if (noPacks && isBundle) { if (bmode !== 'none') bundles.push(li); return; }
          if (okType) singles.push(li);
        });
        let items = lim ? singles.slice(0, lim) : singles;
        if (bmode === 'append' || (bmode === 'fallback' && !singles.length)) items = items.concat(bundles.slice(0, blim));
        row.innerHTML = '';
        items.forEach((li) => row.appendChild(li));
        row.classList.remove('is-loading');
        if (!items.length) {
          /* nothing left (the server hides empty tabs, but stock can change between renders): drop the tab, show the next one */
          b.hidden = true;
          const next = $$('.ks-disc__tab:not([hidden])', tabs)[0];
          if (next) load(next); else row.innerHTML = '<li class="ks-disc__empty">' + (m.dataset.emptyText || '') + '</li>';
          return;
        }
        row.scrollTo({ left: 0 }); upd();
      };
      const load = async (b) => {
        activate(b);
        const url = b.dataset.url; if (!url) return;
        if (b.dataset.inline) { show(b.dataset.inline, b); return; }
        if (cache[url]) { show(cache[url], b); return; }
        row.classList.add('is-loading');
        try {
          const res = await fetch(url, { headers: { Accept: 'text/html' } });
          const txt = await res.text();
          const doc = new DOMParser().parseFromString(txt, 'text/html');
          const inner = doc.querySelector('[data-ks-disc-row]');
          cache[url] = inner ? inner.innerHTML : '';
          show(cache[url], b);
        } catch (e) { row.classList.remove('is-loading'); }
      };
      const first = $('.ks-disc__tab.is-on', tabs);
      if (first) first.dataset.inline = row.innerHTML;
      tabs.addEventListener('click', (e) => { const b = e.target.closest('.ks-disc__tab'); if (b) load(b); });
      row.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd);
      const step = (d) => { const w = row.firstElementChild ? row.firstElementChild.getBoundingClientRect().width + 12 : 200; row.scrollBy({ left: d * w * 2, behavior: 'smooth' }); };
      $('[data-ks-disc-prev]', m)?.addEventListener('click', () => step(-1));
      $('[data-ks-disc-next]', m)?.addEventListener('click', () => step(1));
      upd(); window.addEventListener('load', upd);
    });
  }

  /* ---- quick add (collection cards + cart upsells): the button reveals the sizes in place ---- */
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-ks-qa-open]');
    if (o) { const qa = o.closest('.ks-qa'); if (!qa) return; o.hidden = true; const s = $('.ks-qa__sizes', qa); if (s) s.hidden = false; e.preventDefault(); return; }
  });
  document.addEventListener('submit', (e) => {
    const f = e.target; if (!(f instanceof HTMLFormElement)) return;
    const qa = f.closest('.ks-qa'); if (!qa) return;
    const main = $('[data-ks-qa-open]', qa), sizes = $('.ks-qa__sizes', qa);
    if (main && sizes) {
      setTimeout(() => {
        sizes.hidden = true; main.hidden = false; const old = main.innerHTML;
        main.innerHTML = main.dataset.addedText || '✓'; main.classList.add('is-added');
        setTimeout(() => { main.innerHTML = old; main.classList.remove('is-added'); }, 1600);
      }, 250);
    }
  });

  /* ---- cart: free-pair picker keeps one chosen size for all options ---- */
  function initGiftPick(root) {
    $$('[data-ks-gift-pick]', root).forEach((g) => {
      if (g.dataset.ksReady) return; g.dataset.ksReady = '1';
      const apply = (size) => {
        $$('[data-ks-gift-size]', g).forEach((b) => b.classList.toggle('is-on', b.dataset.ksGiftSize === size));
        $$('[data-ks-gift-opt]', g).forEach((opt) => {
          const v = opt.querySelector('[data-ks-variant-for="' + size + '"]');
          const form = opt.closest('form'); const input = form ? form.querySelector('input[name="id"]') : null;
          if (input && v) { input.value = v.dataset.ksVariantId; opt.disabled = v.dataset.ksAvailable !== 'true'; }
          else opt.disabled = true;
        });
      };
      g.addEventListener('click', (e) => { const b = e.target.closest('[data-ks-gift-size]'); if (b) apply(b.dataset.ksGiftSize); });
      const on = $('[data-ks-gift-size].is-on', g) || $('[data-ks-gift-size]', g); if (on) apply(on.dataset.ksGiftSize);
    });
  }

  /* ---- mouse drag for horizontal strips on desktop; touch keeps native swipe. The vertical wheel is deliberately left to the page
     (an earlier version turned it into horizontal scrolling, which froze page scrolling while the pointer was over a strip) ---- */
  function initDrag(root) {
    $$('[data-ks-disc-tabs], [data-ks-drag], .ks-disc__row, .ks-videos__row, .ks-gift__row, .ks-as__row', root).forEach((el) => {
      if (el.dataset.ksDrag) return; el.dataset.ksDrag = '1'; el.classList.add('ks-drag');
      let down = false, sx = 0, sl = 0, moved = false;
      el.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = el.scrollLeft; el.classList.add('is-dragging'); });
      el.addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true; el.scrollLeft = sl - dx; });
      const up = () => { if (!down) return; down = false; el.classList.remove('is-dragging'); if (moved) { const stop = (ev) => { ev.stopPropagation(); ev.preventDefault(); el.removeEventListener('click', stop, true); }; el.addEventListener('click', stop, true); setTimeout(() => el.removeEventListener('click', stop, true), 50); } };
      el.addEventListener('pointerup', up); el.addEventListener('pointerleave', up);
      el.addEventListener('dragstart', (e) => e.preventDefault());
    });
  }

  /* ---- sticky add-to-cart bar: the size select mirrors the variant picker (click the matching radio so Impact updates price/gallery/URL) ---- */
  document.addEventListener('change', (e) => {
    const s = e.target.closest('[data-ks-sticky-opt]'); if (!s) return;
    const radio = document.querySelector('input[type="radio"][name="' + s.dataset.form + '-option' + s.dataset.position + '"][value="' + s.value + '"]');
    if (radio && !radio.checked) radio.click();
  });

  /* ---- Trustpilot TrustBoxes: the bootstrap script and each widget iframe are only loaded when a box comes within 600px of the
     viewport. KS boxes (.ks-tp__box, sections/ks-trustpilot.liquid) get the trustpilot-widget class at that moment, so the
     bootstrap's own page scan never initialises them early; a box hidden by CSS (the other half of the desktop/mobile pairing)
     has no box to intersect and is left alone until the viewport changes. Legacy .trustpilot-widget markup (homepage custom
     liquid) is still handled: the bootstrap initialises it when it loads. ---- */
  const tpQueue = new Set(); let tpLoading = false;
  const tpBoot = (w) => {
    if (w.dataset.ksTpDone) return; w.dataset.ksTpDone = '1';
    w.classList.add('trustpilot-widget');
    try { window.Trustpilot.loadFromElement(w, true); } catch (e) {}
  };
  const tpLoad = () => {
    if (window.Trustpilot) { tpQueue.forEach(tpBoot); tpQueue.clear(); return; }
    if (tpLoading) return; tpLoading = true;
    const s = document.querySelector('script[src*="tp.widget.bootstrap"]') || document.createElement('script');
    if (!s.parentNode) { s.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'; s.async = true; document.head.appendChild(s); }
    s.addEventListener('load', () => { tpQueue.forEach(tpBoot); tpQueue.clear(); });
  };
  const tpIO = ('IntersectionObserver' in window) ? new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (!en.isIntersecting) return; tpIO.unobserve(en.target); tpQueue.add(en.target); tpLoad(); });
  }, { rootMargin: '600px 0px 600px 0px' }) : null;
  function initTrustpilot(root) {
    const boxes = $$('.ks-tp__box, .trustpilot-widget', root); if (!boxes.length) return;
    boxes.forEach((w) => {
      if (w.dataset.ksTpSeen) return; w.dataset.ksTpSeen = '1';
      if (!tpIO) { tpQueue.add(w); tpLoad(); return; }
      tpIO.observe(w);
    });
  }

  /* ---- cart changes (− / +, remove at 1, gift guard): one queue for the whole cart.
     Taps step the field at once (mobile and desktop selector of the line); one /cart/change.js request per line goes out 300 ms
     after the last tap; requests run strictly one after another (Shopify rejects overlapping changes and line keys can change
     between them, e.g. when a Mix & Match tier is crossed, so the key is re-resolved by variant id before each request).
     The drawer section is bundled in the response and handed to Impact through cart:change, which swaps the drawer content at once.
     "desired" keeps the intended quantity per variant so a re-rendered drawer shows it while a request is still on its way. ---- */
  const ksCart = (function () {
    let chain = Promise.resolve();
    const desired = new Map(); const timers = new Map();
    let fixRounds = 0, fixWindow = 0, lastFix = '', lastFixAt = 0;
    const secId = (el) => { const s = el && el.closest('.shopify-section'); return s ? s.id.replace('shopify-section-', '') : null; };
    const sectionId = () => secId(document.querySelector('cart-drawer'));
    const pageSection = () => document.querySelector('.shopify-section--main-cart');
    /* the /cart page: its section is bundled in the change response and swapped in place (no page reload) */
    const swapPage = (cart) => { const ps = pageSection(); const pid = secId(ps); const html = pid && cart.sections && cart.sections[pid]; if (!ps || !html) return; const tmp = document.createElement('div'); tmp.innerHTML = html; const fresh = tmp.querySelector('.shopify-section') || tmp.firstElementChild; if (fresh) ps.innerHTML = fresh.innerHTML; };
    const vidOf = (key) => String(key).split(':')[0];
    const inputsFor = (key) => $$('.ks-qty input[data-line-key="' + key + '"]');
    const resolveKey = (key) => { if (inputsFor(key).length) return key; const v = vidOf(key); const i = $$('.ks-qty input[data-line-key]').find((x) => vidOf(x.dataset.lineKey) === v); return i ? i.dataset.lineKey : key; };
    const wait = (ms) => new Promise((r) => setTimeout(r, ms));
    const change = (key, qty) => {
      const run = async () => {
        key = resolveKey(key);
        const first = inputsFor(key)[0]; const line = first ? first.closest('line-item') : null;
        if (line) line.dispatchEvent(new CustomEvent('line-item:will-change', { bubbles: true, detail: { targetQuantity: qty } }));
        const sids = [sectionId(), secId(pageSection())].filter(Boolean); let res = null, cart = null;
        try {
          res = await fetch(window.Shopify.routes.root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty, sections: sids }) });
          cart = await res.json();
        } catch (e) { res = null; }
        const v = vidOf(key);
        if (!res || !res.ok || !cart || !cart.items) {
          desired.delete(v);
          if (line) line.dispatchEvent(new CustomEvent('line-item:error', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          await wait(400); return;
        }
        if (desired.get(v) === qty) desired.delete(v);
        const item = cart.items.find((it) => it.key === key);
        if (line) line.dispatchEvent(new CustomEvent('line-item:change', { bubbles: true, detail: { quantity: item ? item.quantity : 0, cart } }));
        swapPage(cart);
        /* baseEvent "variant:add" makes Impact swap the drawer body immediately instead of after its 1.25 s removal animation */
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
        await wait(60);
      };
      chain = chain.then(run, run);
      return chain;
    };
    document.addEventListener('click', (e) => {
      /* "Verwijderen" links on the /cart page go through the queue too (Impact would reload the page) */
      const rm = e.target.closest('.ks-cart-page a[href*="/cart/change"]');
      if (rm) { const u = new URL(rm.href, location.origin); const k = u.searchParams.get('id'); if (k) { e.preventDefault(); e.stopPropagation(); desired.set(vidOf(k), 0); const li = rm.closest('line-item, tr'); if (li) li.classList.add('is-removing'); change(k, 0); } return; }
      const btn = e.target.closest('.ks-qty button'); if (!btn) return;
      const sel = btn.closest('.ks-qty'); const input = $('input', sel); if (!input) return;
      e.stopPropagation(); e.preventDefault();
      const key = input.dataset.lineKey; if (!key) return;
      const v = vidOf(key);
      const cur = desired.has(v) ? desired.get(v) : (parseInt(input.value, 10) || 0);
      const up = btn === sel.querySelector('button:last-of-type');
      const max = parseInt(input.max, 10) || 999999;
      const next = up ? Math.min(cur + 1, max) : Math.max(cur - 1, 0); /* 0 = the line is removed */
      if (next === cur) return;
      desired.set(v, next);
      inputsFor(key).forEach((i) => { i.min = 0; i.value = next; i.style.setProperty('--quantity-input-characters-count', String(next).length + 'ch'); });
      if (next === 0) { const li = input.closest('line-item'); if (li) li.classList.add('is-removing'); }
      clearTimeout(timers.get(v));
      timers.set(v, setTimeout(() => { timers.delete(v); const q = desired.get(v); if (q !== undefined) change(key, q); }, 300));
    }, true);
    /* after every drawer render: show pending quantities, then apply the gift corrections the server rendered (quantity > 1 → 1,
       gift in the cart while its rung is no longer reached → removed). At most 4 correction rounds per 15 s, so a bad configuration can never loop. */
    const sync = (root) => {
      $$('.ks-qty input[data-line-key]', root).forEach((i) => { const v = vidOf(i.dataset.lineKey); if (desired.has(v)) { i.min = 0; i.value = desired.get(v); } });
      $$('script[data-ks-gift-fix]', root).forEach((sc) => {
        if (sc.dataset.ksDone) return; sc.dataset.ksDone = '1';
        let fixes = []; try { fixes = JSON.parse(sc.textContent || '[]'); } catch (e) { fixes = []; }
        const now = Date.now();
        const txt = JSON.stringify(fixes); if (txt === lastFix && now - lastFixAt < 4000) return; lastFix = txt; lastFixAt = now; /* the layout and the drawer both render the same list at page load */
        if (now - fixWindow > 15000) { fixWindow = now; fixRounds = 0; }
        if (!fixes.length || ++fixRounds > 4) return;
        fixes.forEach((f) => change(f.key, f.quantity));
      });
    };
    return { change, sync };
  })();

  /* ---- KS · mobile menu: mark the drawer while a sub-panel is open (the logo hides on level 2; Impact keeps no such state) ---- */
  function initMenu(root) {
    const list = root.matches && root.matches('.navigation-drawer.ks-menu-on') ? [root] : $$('.navigation-drawer.ks-menu-on', root);
    list.forEach((d) => {
      if (d.dataset.ksMenu) return; d.dataset.ksMenu = '1';
      d.addEventListener('click', (e) => { const b = e.target.closest('button[data-panel]'); if (!b) return; d.classList.toggle('is-sub', b.getAttribute('data-panel') !== '0'); });
      d.addEventListener('dialog:after-hide', () => d.classList.remove('is-sub'));
    });
  }

  /* ---- KS · desktop megamenu (8 Sep 2026): close the moment the pointer leaves the open item. Impact's mega-menu-disclosure waits
     500 ms after mouseout; the summary's ::after bridge (ks.css) keeps the path label → panel inside the <details>. ---- */
  function initMega(root) {
    /* Round 5 (8 Sep): a "keep zone" instead of mouseleave. The open item stays open while the pointer is in the bar between
       its neighbours' edges (so the gap next to the label does not close it) or anywhere in the panel; it closes the moment the
       pointer is outside both (Impact's own 500 ms mouseout timer is cancelled while inside the zone). Hover mode, fine pointer only. */
    const navs = root.matches && root.matches('.header__link-list.ks-mega-on') ? [root] : $$('.header__link-list.ks-mega-on', root);
    navs.forEach((nav) => {
      if (nav.dataset.ksMega) return; nav.dataset.ksMega = '1';
      const bar = nav.closest('.header') || nav;
      let raf = 0, lx = 0, ly = 0;
      const check = () => {
        raf = 0;
        const d = nav.querySelector('details.ks-mega[open]');
        if (!d || d.getAttribute('trigger') !== 'hover' || !window.matchMedia('(pointer: fine)').matches) return;
        const li = d.closest('li'), p = d.querySelector('.ks-mega__panel');
        if (!li || !p) return;
        const r = li.getBoundingClientRect(), pr = p.getBoundingClientRect(), br = bar.getBoundingClientRect();
        const prev = li.previousElementSibling, next = li.nextElementSibling;
        const left = prev ? prev.getBoundingClientRect().right : r.left - 24;
        const right = next ? next.getBoundingClientRect().left : r.right + 24;
        const inBar = lx >= left && lx <= right && ly >= br.top && ly <= Math.max(br.bottom, pr.top) + 1;
        const inPanel = lx >= pr.left && lx <= pr.right && ly >= pr.top - 1 && ly <= pr.bottom;
        if (inBar || inPanel) { clearTimeout(d._hoverTimer); return; }
        d.open = false;
      };
      document.addEventListener('mousemove', (e) => { lx = e.clientX; ly = e.clientY; if (!raf) raf = requestAnimationFrame(check); }, { passive: true });
      document.documentElement.addEventListener('mouseleave', () => { const d = nav.querySelector('details.ks-mega[open]'); if (d && d.getAttribute('trigger') === 'hover') d.open = false; });
    });
  }

  /* ---- KS · footer (8 Sep 2026): the link columns collapse on mobile. The class that hides closed groups is only added here,
     so without JavaScript every link stays visible. ---- */
  function initFooter(root) {
    const list = root.matches && root.matches('[data-ks-acc]') ? [root] : $$('[data-ks-acc]', root);
    list.forEach((f) => {
      if (f.dataset.ksReady) return; f.dataset.ksReady = '1'; f.classList.add('ks-footer--acc');
      f.addEventListener('click', (e) => { const b = e.target.closest('.ks-footer__toggle'); if (!b) return; const g = b.closest('.ks-footer__group'); if (!g) return; const open = g.classList.toggle('is-open'); b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    });
  }

  /* ---- KS · Zakelijk (8 Sep 2026): one page, one choice. Profile cards, tabs, form pills and the profile-specific form fields
     share one active profile; deep links /pages/zakelijk#<anker>; sticky mobile bar; lead events for GTM. Bound once with
     document-level delegation, so editor section reloads keep working. ---- */
  const b2b = (() => {
    let key = null; let bound = false;
    const html = document.documentElement;
    const all = (s) => Array.from(document.querySelectorAll(s));
    const esc = (v) => (window.CSS && CSS.escape) ? CSS.escape(v) : String(v).replace(/["\\]/g, '\\$&');
    const push = (o) => { try { (window.dataLayer = window.dataLayer || []).push(o); } catch (e) {} };
    const reduced = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const keyFromHash = (h) => {
      h = (h || '').replace(/^#/, ''); if (!h) return null;
      const el = document.querySelector('[data-b2b-panel][data-b2b-anchor="' + esc(h) + '"], [data-b2b-panel][data-b2b-key="' + esc(h) + '"], [data-b2b-card][data-b2b-anchor="' + esc(h) + '"], input[data-b2b-pill][data-b2b-key="' + esc(h) + '"]');
      return el ? el.dataset.b2bKey : null;
    };
    const keyFromQuery = () => { try { const q = new URLSearchParams(location.search).get('profiel'); return q ? keyFromHash(q) : null; } catch (e) { return null; } };
    function sync() {
      all('[data-b2b-card]').forEach((c) => { const on = c.dataset.b2bKey === key; const li = c.closest('.ks-b2b-card'); if (li) li.classList.toggle('is-active', on); if (c.hasAttribute('aria-pressed')) c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      all('[data-b2b-tab]').forEach((t) => { const on = t.dataset.b2bKey === key; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      all('[data-b2b-panel]').forEach((p) => { p.classList.toggle('is-active', p.dataset.b2bKey === key); });
      all('input[data-b2b-pill]').forEach((i) => { i.checked = i.dataset.b2bKey === key; });
      all('[data-b2b-for]').forEach((f) => {
        const list = (f.dataset.b2bFor || '').split(',').map((s) => s.trim()).filter(Boolean);
        const show = !list.length || (key && list.includes(key));
        f.hidden = !show;
        f.querySelectorAll('input,select,textarea').forEach((i) => { i.disabled = !show; });
      });
    }
    function set(k, opts) {
      opts = opts || {}; if (!k) return; const changed = k !== key; key = k; html.classList.add('ks-b2b-js'); sync();
      if (opts.hash) { const el = document.querySelector('[data-b2b-panel][data-b2b-key="' + esc(k) + '"]'); const a = el && el.dataset.b2bAnchor; if (a) { try { history.replaceState(null, '', '#' + a); } catch (e) {} } }
      if (opts.scroll) { const target = document.querySelector('[data-b2b-panels]'); if (target) target.scrollIntoView({ behavior: (reduced() || opts.instant) ? 'auto' : 'smooth', block: 'start' }); }
      if (changed && opts.user) push({ event: 'ks_b2b_profile', b2b_profile: k });
    }
    function bind() {
      if (bound) return; bound = true;
      document.addEventListener('click', (e) => {
        const card = e.target.closest('[data-b2b-card]');
        if (card) { e.preventDefault(); set(card.dataset.b2bKey, { hash: true, scroll: true, user: true }); return; }
        const tab = e.target.closest('[data-b2b-tab]');
        if (tab) { set(tab.dataset.b2bKey, { hash: true, user: true }); return; }
        const go = e.target.closest('[data-b2b-go]');
        if (go) { set(go.dataset.b2bKey, { user: true }); }
      });
      document.addEventListener('change', (e) => { const pill = e.target.closest ? e.target.closest('input[data-b2b-pill]') : null; if (pill && pill.checked) set(pill.dataset.b2bKey, { user: true }); });
      window.addEventListener('hashchange', () => { const k = keyFromHash(location.hash); if (k) set(k, { scroll: true }); });
      document.addEventListener('submit', (e) => {
        const f = e.target; if (!f || !f.matches || !f.matches('#ks-b2b-form')) return;
        try { sessionStorage.setItem('ks_b2b_profile', key || ''); } catch (err) {}
        push({ event: 'ks_b2b_submit', b2b_profile: key || '' });
      });
    }
    function sticky() {
      const bar = document.querySelector('[data-b2b-sticky]'); if (!bar || bar.dataset.ksReady) return; bar.dataset.ksReady = '1';
      const hero = document.querySelector('[data-b2b-hero]'); const form = document.querySelector('[data-b2b-form-wrap]');
      if (!hero || !('IntersectionObserver' in window)) return;
      let heroIn = true, formIn = false;
      const upd = () => { bar.hidden = heroIn || formIn; };
      new IntersectionObserver((en) => { heroIn = en[0].isIntersecting; upd(); }, { threshold: 0 }).observe(hero);
      if (form) new IntersectionObserver((en) => { formIn = en[0].isIntersecting; upd(); }, { threshold: 0.05 }).observe(form);
    }
    function success() {
      const s = document.querySelector('[data-b2b-success]'); if (!s || s.dataset.ksReady) return; s.dataset.ksReady = '1';
      let p = ''; try { p = sessionStorage.getItem('ks_b2b_profile') || ''; sessionStorage.removeItem('ks_b2b_profile'); } catch (e) {}
      push({ event: 'ks_b2b_lead', b2b_profile: p });
      requestAnimationFrame(() => { try { s.scrollIntoView({ behavior: 'auto', block: 'center' }); } catch (e) {} });
    }
    let started = false;
    function init() {
      const root = document.querySelector('[data-b2b-default]');
      if (!root && !document.querySelector('[data-b2b-panel], input[data-b2b-pill]')) return;
      bind(); sticky(); success();
      /* the URL only decides the profile on the first run; later runs (Impact/apps add nodes, editor section reloads) keep
         whatever the visitor chose since — otherwise a card click followed by any DOM change snapped back to the hash */
      const fromUrl = started ? null : (keyFromHash(location.hash) || keyFromQuery()); started = true;
      const first = document.querySelector('[data-b2b-panel], input[data-b2b-pill]');
      const k = fromUrl || key || (root && root.dataset.b2bDefault) || (first && first.dataset.b2bKey);
      if (k) set(k, { scroll: !!fromUrl, instant: true }); else sync();
    }
    return { init };
  })();
  function initB2B(root) { b2b.init(); }

  /* ---- KS · FAQ page (8 Sep 2026, sections/ks-faq-page.liquid): the search field filters the questions (accent-insensitive,
     every word must match question + answer + hidden keywords), empty topics and their chips disappear, matches open while a
     query is active and close again when it is cleared; a #q-<vraag> link (from a Snel geregeld tile, the footer or an e-mail)
     opens that question; the topic chips follow the scroll. Without JavaScript the page is complete as rendered. ---- */
  function initFaq(root) {
    const list = root.matches && root.matches('[data-ks-faq]') ? [root] : $$('[data-ks-faq]', root);
    list.forEach((f) => {
      if (f.dataset.ksReady) return; f.dataset.ksReady = '1';
      const items = $$('[data-ks-faq-item]', f), groups = $$('[data-ks-faq-group]', f), nav = f.querySelector('[data-ks-faq-nav]');
      const q = f.querySelector('[data-ks-faq-q]'), clear = f.querySelector('[data-ks-faq-clear]'), empty = f.querySelector('[data-ks-faq-empty]');
      const norm = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
      items.forEach((it) => { it.dataset.ksFaqN = norm(it.dataset.ksFaqText); });
      const autoOpen = (it, on) => {
        const d = it.querySelector('details'); if (!d) return;
        if (on) { if (!d.open) { d.dataset.ksFaqAuto = '1'; d.open = true; } }
        else if (d.dataset.ksFaqAuto) { delete d.dataset.ksFaqAuto; d.open = false; }
      };
      function filter() {
        const terms = norm(q ? q.value.trim() : '').split(/\s+/).filter(Boolean); let n = 0;
        items.forEach((it) => { const hit = !terms.length || terms.every((t) => it.dataset.ksFaqN.indexOf(t) !== -1); it.hidden = !hit; if (hit) n++; autoOpen(it, terms.length > 0 && hit); });
        groups.forEach((g) => {
          const any = $$('[data-ks-faq-item]', g).some((it) => !it.hidden); g.hidden = !any;
          const a = nav && g.id ? nav.querySelector('a[href="#' + g.id + '"]') : null; if (a) a.parentElement.hidden = !any;
        });
        if (empty) empty.hidden = n > 0;
        if (clear) clear.hidden = !terms.length;
        f.classList.toggle('is-filtering', terms.length > 0);
      }
      if (q) {
        q.addEventListener('input', filter);
        q.addEventListener('keydown', (e) => { if (e.key === 'Escape') { q.value = ''; filter(); } });
        if (q.value) filter();
      }
      if (clear) clear.addEventListener('click', () => { if (q) { q.value = ''; q.focus(); } filter(); });
      const fromHash = () => {
        const h = decodeURIComponent(location.hash.replace(/^#/, '')); if (!h) return;
        let d; try { d = document.getElementById(h); } catch (e) { return; }
        if (!d || !f.contains(d)) return;
        if (d.matches('details') && !d.open) d.open = true;
        requestAnimationFrame(() => d.scrollIntoView({ block: 'start' }));
      };
      window.addEventListener('hashchange', fromHash); fromHash();
      if (nav && groups.length) {
        const links = $$('a', nav); let last = '', ticking = false;
        const set = (id) => {
          if (id === last) return; last = id;
          links.forEach((a) => {
            const on = a.getAttribute('href') === '#' + id; a.classList.toggle('is-on', on);
            if (on) { const r = a.getBoundingClientRect(), nr = nav.getBoundingClientRect(); if (r.left < nr.left || r.right > nr.right) a.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); }
          });
        };
        /* active topic = the last group whose top is in the upper third of the screen (or has passed the chip row) */
        const pick = () => {
          ticking = false; const limit = Math.max(nav.getBoundingClientRect().bottom + 24, innerHeight * 0.35); let cur = '';
          groups.forEach((g) => { if (g.id && !g.hidden && g.getBoundingClientRect().top <= limit) cur = g.id; });
          if (!cur) { const first = groups.find((g) => g.id && !g.hidden); cur = first ? first.id : ''; }
          if (cur) set(cur);
        };
        window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(pick); } }, { passive: true });
        window.addEventListener('resize', pick); pick();
      }
    });
  }

  /* ---- KS · sticky add-to-cart bar (10 Sep 2026): Impact's <product-quick-add> looks for `.footer` to know where the bar must hide
     again, and bails out of connectedCallback when it is missing. The KS footer replaced Impact's footer (8 Sep), so the bar never
     appeared on any device. Same rule as Impact (buy-box form scrolled past AND footer not in view), scoped to the KS footer. ---- */
  function initSticky(root) {
    const bars = root.matches && root.matches('product-quick-add.ks-sticky') ? [root] : $$('product-quick-add.ks-sticky', root);
    bars.forEach((bar) => {
      if (bar.dataset.ksSticky || document.querySelector('.footer')) return; bar.dataset.ksSticky = '1';
      const from = document.getElementById(bar.getAttribute('form'));
      const to = document.querySelector('.shopify-section--footer, .ks-footer');
      if (!from || !to) return;
      let passed = false, reached = false, raf = 0;
      const apply = () => bar.classList.toggle('is-visible', passed && !reached);
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.target === from) passed = e.boundingClientRect.bottom < 0; if (e.target === to) reached = e.isIntersecting; });
        apply();
      });
      io.observe(from); io.observe(to);
      /* A jump from the bottom straight to the top (iOS status-bar tap, "scroll to top" buttons) moves the buy box from above
         the viewport to below it without ever intersecting, so the observer never fires and the bar would stay visible over
         the gallery. Re-measure on scroll, one frame at a time. */
      window.addEventListener('scroll', () => { if (raf) return; raf = requestAnimationFrame(() => { raf = 0; if (!bar.isConnected) return; passed = from.getBoundingClientRect().bottom < 0; apply(); }); }, { passive: true });
    });
  }

  /* ---- KS · size must be chosen (10 Sep 2026, theme setting ks_require_size; Tako: fewer wrong-size orders) ----
     Impact pre-selects the first available variant. On a plain product URL (no ?variant=) we uncheck the size radios, clear the
     form's variant id, turn every submit button for the form into a disabled "Kies eerst je maat" and give the sticky bar's select a
     placeholder. Impact's own variant:change (fired when a size is tapped) releases the gate; the re-rendered blocks then carry the
     chosen variant. Only the size option is gated (Bio Essentials also has a pack option, which keeps its default). ---- */
  function initSizeGate(root) {
    const pickers = root.matches && root.matches('variant-picker[data-ks-require-size]') ? [root] : $$('variant-picker[data-ks-require-size]', root);
    pickers.forEach((vp) => {
      if (vp.dataset.ksGate) return; vp.dataset.ksGate = '1';
      if (/[?&]variant=/.test(location.search)) return;
      const formId = vp.getAttribute('form-id'); const form = document.forms[formId]; if (!form) return;
      const names = (vp.dataset.ksSizeNames || 'maat,size').split(',').map((n) => n.trim());
      const sets = $$('.variant-picker__option', vp);
      const fs = sets.find((f) => { const l = $('legend', f); return l && names.includes(l.textContent.replace(':', '').trim().toLowerCase()); }) || (sets.length === 1 ? sets[0] : null);
      if (!fs) return;
      const radios = $$('input[type="radio"][data-option-position]', fs);
      if (radios.length < 2) return;
      radios.forEach((r) => { r.checked = false; });
      const idInput = form.querySelector('input[name="id"]'); if (idInput) idInput.value = '';
      const valueSpan = $('.variant-picker__option-info span', fs);
      if (valueSpan) valueSpan.textContent = vp.dataset.ksChooseSize || 'Kies je maat';
      const buttons = () => $$('button[type="submit"][form="' + formId + '"]').concat($$('button[type="submit"]', form));
      const selects = () => $$('select[data-ks-sticky-opt][data-form="' + formId + '"]');
      const lock = () => {
        buttons().forEach((b) => { if (b.dataset.ksGated) return; b.dataset.ksGated = '1'; b.dataset.ksLabel = b.innerHTML; b.disabled = true; b.setAttribute('aria-disabled', 'true'); b.innerHTML = '<span>' + (vp.dataset.ksChooseFirst || 'Kies eerst je maat') + '</span>'; });
        selects().forEach((s) => { if (s.querySelector('option[data-ks-ph]')) return; const o = document.createElement('option'); o.value = ''; o.textContent = vp.dataset.ksChooseSize || 'Kies je maat'; o.dataset.ksPh = '1'; s.insertBefore(o, s.firstChild); o.selected = true; });
      };
      const release = () => {
        delete vp.dataset.ksNosize;
        buttons().forEach((b) => { if (!b.dataset.ksGated) return; b.disabled = false; b.removeAttribute('aria-disabled'); b.innerHTML = b.dataset.ksLabel; delete b.dataset.ksGated; delete b.dataset.ksLabel; });
        selects().forEach((s) => { const o = s.querySelector('option[data-ks-ph]'); if (o) o.remove(); });
      };
      vp.dataset.ksNosize = '1'; lock();
      form.addEventListener('variant:change', release, { once: true });
    });
  }

  /* ---- search (11 Sep 2026): KS layer on Impact's <predictive-search>. Why: on translated storefronts (.com/.de/.fr/.co.uk/.ch)
     Shopify's predictive API only matches translated TITLES — no tags, type, vendor or translated description — so "vincent van
     gogh" on kunstsokken.com found nothing (43% of all searches last year returned nothing). Every query now runs: predictive
     API → full search (a section render of /search, which does index descriptions and tags on every storefront) → query
     variants (typo fixes, first names and "socks" dropped, the current storefront's title from assets/ks-search-index.json,
     extra synonyms from the theme setting). snippets/ks-search-results re-ranks and renders; here: the FAQ hint for service
     questions, "did you mean" chips on zero results, the retry of a zero-result /search page, chips that run a search, the
     drawer's deferred photos, closing the drawer after a quick add, and a dataLayer event per search. ---- */
  const ksSearch = (() => {
    let cfg = null, indexP = null;
    const readCfg = () => { if (cfg) return cfg; const el = document.querySelector('[data-ks-search-cfg]'); try { cfg = el ? JSON.parse(el.textContent) : null; } catch (e) { cfg = null; } return cfg; };
    const norm = (s) => (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
    const FIRST = ['vincent', 'claude', 'gustav', 'henri', 'wassily', 'piet', 'edvard', 'edward', 'johannes', 'caspar', 'casper', 'leonardo', 'katsushika', 'franz', 'paul', 'albrecht', 'jan', 'charley', 'hendrick', 'emile', 'salvador', 'frida', 'pablo', 'rene', 'yayoi', 'keith', 'edgar', 'joan', 'egon', 'hilma', 'theo'];
    const NOISE = ['sokken', 'sok', 'socks', 'sock', 'socken', 'socke', 'chaussettes', 'chaussette', 'kunstsokken', 'kunstsocken', 'art', 'kunst', 'de', 'het', 'the', 'der', 'die', 'das', 'le', 'la', 'les', 'van', 'von', 'of', 'calcetines', 'calcetin', 'el', 'la', 'los', 'las', 'del', 'arte'];
    const TYPO = { kadinsky: 'kandinsky', kandinski: 'kandinsky', kansinky: 'kandinsky', kadinski: 'kandinsky', kandinsk: 'kandinsky', kandin: 'kandinsky', vangogh: 'van gogh', 'van goch': 'van gogh', 'van gogh s': 'van gogh', goch: 'gogh', money: 'monet', monnet: 'monet', matise: 'matisse', mathisse: 'matisse', klimpt: 'klimt', hokusay: 'hokusai', hoku: 'hokusai', munk: 'munch', khalo: 'kahlo', frieda: 'frida', piccasso: 'picasso', bansky: 'banksy', margritte: 'magritte', rembrand: 'rembrandt', vermeeer: 'vermeer', mondrain: 'mondriaan', 'franz mark': 'franz marc', 'casper david friedrich': 'caspar david friedrich', 'edward munch': 'edvard munch', 'delf': 'delft', 'delfts blauw': 'delfts blauw', 'gogh van': 'van gogh' };
    const lev = (a, b) => { if (a === b) return 0; if (!a.length) return b.length; if (!b.length) return a.length; let prev = Array.from({ length: b.length + 1 }, (_, i) => i); for (let i = 1; i <= a.length; i++) { const cur = [i]; for (let j = 1; j <= b.length; j++) cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)); prev = cur; } return prev[b.length]; };
    const loadIndex = () => { const c = readCfg(); if (!c || !c.index) return Promise.resolve(null); if (!indexP) indexP = fetch(c.index, { credentials: 'omit' }).then((r) => (r.ok ? r.json() : null)).catch(() => null); return indexP; };
    const locOf = (c) => { const l = (c && c.locale || 'nl').slice(0, 2); return ['nl', 'en', 'de', 'fr', 'es'].includes(l) ? l : 'en'; };
    /* extra synonyms (theme setting): one group per line, "words, comma separated => what to search for" */
    const extras = (c) => (c && c.extra || '').split(/\r?\n/).map((l) => l.split('=>')).filter((p) => p.length === 2).map((p) => ({ a: p[0].split(',').map(norm).filter(Boolean), c: p[1].trim() }));
    /* the current storefront's title of the product whose title (any language) or tag best matches the query */
    const fromIndex = (q, idx, c) => {
      if (!idx || !idx.p) return null;
      const toks = q.split(' ').filter((w) => w.length >= 3); if (!toks.length) return null;
      const loc = locOf(c); let best = null, bestScore = 0, viaTag = 0;
      idx.p.forEach((p) => {
        let score = 0, tagOnly = true;
        const test = (s, isTag) => {
          s = norm(s); if (!s) return; let v = 0;
          if (s === q) v = 100; else if (s.includes(q)) v = 60; else { const words = s.split(' '); const hit = toks.filter((w) => words.some((sw) => sw === w || (w.length >= 4 && sw.startsWith(w)))).length; v = hit === toks.length ? 40 : 0; }
          if (v > score) { score = v; tagOnly = isTag; } else if (v && v === score && !isTag) tagOnly = false;
        };
        Object.keys(p.t || {}).forEach((k) => test(p.t[k], false)); (p.x || []).forEach((x) => test(x, true));
        if (!score) return; if (p.s) score += 1; if (p.v === 0) score -= 5;
        if (score > bestScore) { bestScore = score; best = p; viaTag = tagOnly ? 1 : 0; }
      });
      if (!best || bestScore < 40 || viaTag) return null; /* a tag hit (artist name) is not one product: the full search + artist chips handle it */
      const title = best.t[loc] || best.t.en || best.t.nl; return norm(title) === q ? null : title;
    };
    const variants = (raw, idx, c) => {
      const q = norm(raw), out = [raw.trim()];
      const push = (v) => { v = (v || '').trim(); if (v && !out.some((o) => norm(o) === norm(v))) out.push(v); };
      let t = ' ' + q + ' '; Object.keys(TYPO).sort((a, b) => b.length - a.length).forEach((k) => { t = t.split(' ' + k + ' ').join(' ' + TYPO[k] + ' '); }); t = t.trim(); push(t);
      const noFirst = t.split(' ').filter((w) => !FIRST.includes(w)).join(' '); if (noFirst && noFirst !== t) push(noFirst);
      const clean = noFirst.split(' ').filter((w) => !NOISE.includes(w)).join(' '); if (clean && clean !== noFirst) push(clean);
      extras(c).forEach((g) => { if (g.a.some((a) => a === q || (' ' + q + ' ').includes(' ' + a + ' '))) push(g.c); });
      const ix = fromIndex(clean || t, idx, c); if (ix) push(ix);
      return out.slice(0, 5);
    };
    const cache = new Map();
    const render = async (url, signal) => { if (cache.has(url)) return cache.get(url); const r = await fetch(url, { signal }); const t = await r.text(); if (r.ok) cache.set(url, t); return t; };
    const parse = (text) => { const doc = new DOMParser().parseFromString(text, 'text/html'); const res = doc.querySelector('[slot="results"]'); const box = res && res.querySelector('[data-ks-search-results]'); const n = (k) => (box ? parseInt(box.dataset[k], 10) || 0 : 0); return { node: res, count: n('ksCount'), hits: n('ksHits'), strong: n('ksStrong') }; };
    const predUrl = (c, q, sid) => c.root + 'search/suggest?q=' + encodeURIComponent(q) + '&section_id=' + sid + '&resources[type]=product,collection&resources[limit]=' + Math.min(c.limit || 12, 10) + '&resources[limit_scope]=each&resources[options][unavailable_products]=last';
    const fullUrl = (c, q, sid) => c.root + 'search?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last&section_id=' + sid;
    const go = (url, signal) => render(url, signal).then(parse).catch((e) => { if (e && e.name === 'AbortError') throw e; return null; });
    /* one query: predictive and full search side by side on every storefront; the response with more direct title/artist hits
       wins, then more hits overall, then the predictive one (typo tolerance). Predictive alone returned Shopify's top 10 by its own
       relevance, which for "hokusai" or "van gogh" is bundles that mention the artist while the single designs sit outside the ten
       (Tako, 11 Sep); the full search hands over the top 24 and the re-ranking puts the designs first. */
    const askOne = async (c, q, sid, signal, pred) => {
      if (!pred) return go(fullUrl(c, q, sid), signal);
      if (c.fullFallback === false) return go(predUrl(c, q, sid), signal);
      const [a, b] = await Promise.all([go(predUrl(c, q, sid), signal), go(fullUrl(c, q, sid), signal)]);
      if (!a) return b; if (!b) return a;
      if (b.strong > a.strong) return b; if (a.strong > b.strong) return a;
      if (b.hits > a.hits) return b; if (a.hits > b.hits) return a;
      return a.count ? a : b;
    };
    async function run(el, usePredictive) {
      const c = readCfg(); if (!c) return;
      await el._transitionToSlot('loading');
      const raw = el._queryInput.value.trim(); if (!raw) return el._onSearchCleared();
      const sid = el.getAttribute('section-id'), signal = el._abortController.signal, pred = usePredictive && el.supportsPredictiveApi();
      try {
        const idx = await loadIndex(); if (signal.aborted) return;
        const vars = variants(raw, idx, c); let best = null, soft = null, first = null, used = raw;
        for (const q of vars) {
          const r = await askOne(c, q, sid, signal, pred); if (signal.aborted) return; if (!r) continue;
          if (r.hits > 0) { best = r; used = q; break; }
          if (r.count > 0 && !soft) { soft = r; soft.q = q; }
          if (!first) first = r; /* the zero state, if it comes to that, quotes the visitor's own words */
        }
        const fin = best || soft || first; if (!fin || !fin.node) { el.querySelector('[slot="results"]').innerHTML = ''; return el._transitionToSlot('results'); }
        used = best ? used : soft ? soft.q : raw;
        const node = document.importNode(fin.node, true);
        el.querySelector('[slot="results"]').replaceWith(node);
        const form = el.closest('form'); if (form) { form.dataset.ksEffective = used; form.dataset.ksEffectiveFor = raw; }
        decorate(node, raw, used, fin, idx, c);
        init(node);
        window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'ks_search', ks_term: raw, ks_effective: used, ks_results: fin.count, ks_hits: fin.hits, ks_locale: c.locale });
        return el._transitionToSlot('results');
      } catch (e) { if (!e || e.name !== 'AbortError') console.warn('ks search', e); }
    }
    /* service topics (shipping, returns, sizes …) get a line with a FAQ link, whatever the product results say */
    const serviceHint = (box, q, c) => {
      const svc = box.querySelector('[data-ks-search-svc]'); if (!svc || !c.svc) return;
      const qq = ' ' + norm(q) + ' '; const hits = [];
      Object.keys(c.svc).forEach((k) => { const e = c.svc[k]; if ((e.a || '').split(',').some((a) => { a = norm(a); return a && qq.includes(' ' + a + ' '); })) hits.push(e); });
      if (!hits.length) return;
      svc.innerHTML = '<span>' + c.t.svc + '</span>' + hits.slice(0, 2).map((e) => '<a href="' + c.faq + '#q-' + e.id + '">' + e.label + ' →</a>').join('');
      svc.hidden = false;
    };
    /* "did you mean": the closest product titles (this storefront's language) and artist names */
    const didYouMean = (box, q, idx, c) => {
      const dym = box.querySelector('[data-ks-search-dym]'); if (!dym) return;
      const qn = norm(q); if (qn.length < 3) return;
      const loc = locOf(c); const cands = [];
      (c.artists || []).forEach((a) => cands.push(a.l));
      if (idx && idx.p) idx.p.forEach((p) => { if (p.t && p.t[loc]) cands.push(p.t[loc]); });
      const seen = new Set(); const scored = [];
      cands.forEach((cand) => { const cn = norm(cand); if (!cn || seen.has(cn)) return; seen.add(cn);
        let d = lev(qn, cn); cn.split(' ').forEach((w) => { if (w.length >= 4) d = Math.min(d, lev(qn, w) + 0.5); });
        const max = qn.length <= 4 ? 1 : qn.length <= 8 ? 2 : 3; if (d > 0 && d <= max) scored.push([d, cand]); });
      scored.sort((a, b) => a[0] - b[0]);
      const top = scored.slice(0, 3); if (!top.length) return;
      dym.innerHTML = '<span>' + c.t.dym + '</span>' + top.map(([, cand]) => '<button type="button" class="ks-search__chip" data-ks-search-term="' + cand.replace(/"/g, '&quot;') + '">' + cand + '</button>').join('');
      dym.hidden = false;
    };
    const decorate = (node, raw, used, fin, idx, c) => { serviceHint(node, raw, c); if (fin.count === 0) didYouMean(node, used, idx, c); };
    const patch = () => { const P = customElements.get('predictive-search'); if (!P || P.prototype.ksPatched) return; P.prototype.ksPatched = true; P.prototype._doPredictiveSearch = function () { return run(this, true); }; P.prototype._doFallbackSearch = function () { return run(this, false); }; };
    /* the results page: FAQ hint, and on zero results first retry the query as a variant (server-side check through the drawer
       section), then "did you mean" chips */
    const page = async (box) => {
      const c = readCfg(); if (!c) return; const q = box.dataset.ksQuery || '', count = parseInt(box.dataset.ksCount, 10) || 0;
      serviceHint(box, q, c);
      const params = new URLSearchParams(location.search); const from = params.get('ks_from');
      if (from) { const note = box.querySelector('[data-ks-search-note]') || box.querySelector('h1'); if (note && c.t.searched) { const p = document.createElement('p'); p.className = 'ks-search__text ks-search__from'; p.textContent = c.t.searched.replace('%s', from); note.insertAdjacentElement('afterend', p); } }
      if (count > 0 || !q) return;
      const idx = await loadIndex(); const vars = variants(q, idx, c).slice(1);
      const ps = document.querySelector('predictive-search[section-id]'); const sid = ps && ps.getAttribute('section-id');
      if (sid && !from) {
        for (const v of vars) { const r = await go(fullUrl(c, v, sid)); if (r && r.count > 0) { location.replace(c.search + '?q=' + encodeURIComponent(v) + '&type=product&options[prefix]=last&ks_from=' + encodeURIComponent(q)); return; } }
      }
      didYouMean(box, q, idx, c);
    };
    return { patch, page, loadIndex, readCfg };
  })();
  function initSearch(root) {
    if (root === document) {
      if ('customElements' in window) customElements.whenDefined('predictive-search').then(ksSearch.patch).catch(() => {});
      /* chips: inside the drawer they run a search, elsewhere they open the results page */
      document.addEventListener('click', (e) => {
        const b = e.target.closest('[data-ks-search-term]'); if (!b) return;
        const term = b.dataset.ksSearchTerm || b.textContent.trim(); const form = b.closest('form[data-ks-search-form]'); const c = ksSearch.readCfg();
        if (form && form.elements.q) { e.preventDefault(); form.elements.q.value = term; form.elements.q.dispatchEvent(new Event('input', { bubbles: true })); form.elements.q.focus(); return; }
        const drawerForm = document.querySelector('#search-drawer form[data-ks-search-form]'); const drawer = document.getElementById('search-drawer');
        if (drawerForm && drawer && drawer.hasAttribute('open')) { e.preventDefault(); drawerForm.elements.q.value = term; drawerForm.elements.q.dispatchEvent(new Event('input', { bubbles: true })); return; }
        if (c) { e.preventDefault(); location.href = c.search + '?q=' + encodeURIComponent(term) + '&type=product&options[prefix]=last'; }
      });
      /* the drawer's form submits the query that actually produced results (a typo fix or the storefront's own title) */
      document.addEventListener('submit', (e) => { const f = e.target; if (!f.matches || !f.matches('form[data-ks-search-form]')) return; const inp = f.elements.q; if (!inp) return; if (f.dataset.ksEffective && f.dataset.ksEffectiveFor === inp.value.trim() && f.dataset.ksEffective !== inp.value.trim()) inp.value = f.dataset.ksEffective; }, true);
      /* a quick add from the search results: let the cart drawer take over */
      document.addEventListener('variant:add', () => { const d = document.getElementById('search-drawer'); if (d && d.hasAttribute('open') && typeof d.hide === 'function') d.hide(); });
    }
    /* the closed drawer holds the deferred bestseller photos: swap them when it opens, and warm the index */
    const list = root.matches && root.matches('#search-drawer') ? [root] : $$('#search-drawer', root);
    list.forEach((d) => {
      if (d.dataset.ksSearchDrawer) return; d.dataset.ksSearchDrawer = '1';
      const onOpen = () => { if (!d.hasAttribute('open')) return; $$('[data-ks-defer]', d).forEach((c) => { c.dataset.ksDeferOn = '1'; }); swapDeferred(d); ksSearch.loadIndex(); };
      new MutationObserver(onOpen).observe(d, { attributes: true, attributeFilter: ['open'] }); onOpen();
      const inp = d.querySelector('input[name="q"]'); if (inp) inp.addEventListener('focus', () => ksSearch.loadIndex(), { once: true });
    });
    const pages = root.matches && root.matches('[data-ks-search-page]') ? [root] : $$('[data-ks-search-page]', root);
    pages.forEach((box) => { if (box.dataset.ksSearchPageOn) return; box.dataset.ksSearchPageOn = '1'; ksSearch.page(box); });
  }

  function init(root) { initSticky(root); initSizeGate(root); initFooter(root); initMega(root); initMenu(root); initUsp(root); initMarquee(root); initDiscover(root); initGiftPick(root); initDrag(root); initTrustpilot(root); initDefer(root); initDrawerDefer(root); initZeroHide(root); initMetaFit(root); initDeferX(root); initB2B(root); initFaq(root); initSearch(root); ksCart.sync(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  /* Impact re-renders the cart drawer and product sections; pick up new nodes. Speed (6 Sep 2026): added nodes are collected and
     initialised once per animation frame instead of one full scan per node (apps and Impact insert hundreds of nodes at load);
     a node whose ancestor is already in the batch is skipped. */
  const pendingNodes = new Set(); let flushScheduled = false;
  const flush = () => {
    flushScheduled = false;
    const nodes = [...pendingNodes]; pendingNodes.clear();
    nodes.forEach((n) => { if (!n.isConnected) return; if (nodes.some((o) => o !== n && o.contains(n))) return; init(n); });
  };
  new MutationObserver((muts) => {
    for (const mu of muts) for (const n of mu.addedNodes) if (n.nodeType === 1) pendingNodes.add(n);
    if (pendingNodes.size && !flushScheduled) { flushScheduled = true; requestAnimationFrame(flush); }
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
